export const formDataBuilder = (file: File | Blob, id: string) => {
  var fileData = new FormData();
  fileData.append("input[demo_model_id]", id);
  fileData.append("input[file]", file);
  return fileData;
};
